module.exports = __webpack_public_path__ + "static/Flavor_18AMT90225-ff0b1527cb50f5c7c570804e29d1364c.pdf";